import { render, staticRenderFns } from "./IconSaveFilled.vue?vue&type=template&id=b9a86f9a&scoped=true"
import script from "./IconSaveFilled.vue?vue&type=script&lang=js"
export * from "./IconSaveFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a86f9a",
  null
  
)

export default component.exports